import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import NoResults from "./NoResults";
import { ArticleCardSkeleton } from "./ArticleCardSkeleton";
import { ArticleCard } from "./ArticleCard";
import { Article, ArticleHit } from "../article";
import { useIndexName } from "./IndexNameProvider";
import ShowAllResultsButton from "@/frontend/algolia/components/ShowAllResultsButton";
import { searchIndexes } from "../../search-shared/client";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";

function ArticleHitsContent() {
    const { status } = useInstantSearch();
    const { items } = useHits<Article>();

    const onSelect = (hit: ArticleHit) => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/blogs/${hit.blog.handle}/${hit.handle}`;
    }

    const onShowAll = () => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/blogs/${items[0]?.blog.handle || "news"}`;
    }

    return (
        <>
            <div className="tw-grid tw-auto-rows-fr tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-5">
                {((status === "loading" || status === "stalled")) &&
                    Array(4).fill(null).map((_, index) => <ArticleCardSkeleton key={index} />)
                }
                {(status === "idle") && items.length > 0 ?
                    items.map((item) => <ArticleCard key={item.objectID} onSelect={onSelect} articleHit={item} layout="vertical" />)
                    : <NoResults />}
            </div>

            {items.length > 0 && <ShowAllResultsButton onClick={onShowAll} text="Show all articles" className="tw-py-20" />}
        </>
    )
}

export default function ArticleHits() {
    const { articles_autocomplete_hits_per_page = 4 } = window.algoliaShopify.config;
    const { indexName: currentIndex } = useIndexName();
    const { query } = useSearchBox();

    return (
        <Index indexName={searchIndexes.ARTICLES}>
            <VirtualSearchBox />
            <Configure
                hitsPerPage={articles_autocomplete_hits_per_page}
                query={query}
            />
            {currentIndex === searchIndexes.ARTICLES &&
                <ArticleHitsContent />
            }
        </Index>
    )
}


// @TODO Performance Fix?:
// On mount of ArticleHits' parent component, we are doing a federated search to Algolia for all the data.
// When we change the currentIndex, this component re-renders and does another federated query to algolia.
// How can we memo the data so it doesn't do a repeat call to the API index change?